import React, { useState } from "react";
import "./Forecast.css";
import axios from "axios";

import WeatherForecastCom from "./WeatherForecastComp";

export default function Forecast(props) {
  let [loaded, setLoaded] = useState(false);
  let [forecast, setForecast] = useState(null);
  let city = props.city;

  function handleResponse(response) {
    setForecast(response.data);
    setLoaded(true);
  }

  if (loaded && props.city === forecast.city.name) {
    return (
      <div className="forecast row">
        <WeatherForecastCom forecast={forecast.list[0]} />
        <WeatherForecastCom forecast={forecast.list[1]} />
        <WeatherForecastCom forecast={forecast.list[2]} />
        <WeatherForecastCom forecast={forecast.list[3]} />
        <WeatherForecastCom forecast={forecast.list[4]} />
      </div>
    );
  } else {
    let apiKey = "b28b299373888e2964f50f45cbe15efa";
    let apiUrl = `https://api.openweathermap.org/data/2.5/forecast?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);
    return null;
  }
}
